const responsibilities = [
  {
    title: 'Strategic Posting of Tech Job Opportunities',
    description: 'Discover how top tech companies strategically post job openings across various platforms, leveraging talent sourcing channels to attract highly qualified candidates for your organization.',
  },
  {
    title: 'Building Strong Connections with Tech Professionals',
    description: 'Learn how to foster meaningful relationships with potential tech talent. Leading organizations use innovative strategies beyond traditional methods to engage and attract top tech candidates for your projects.',
  },
  {
    title: 'Thorough Talent Assessment through Technical Interviews',
    description: 'Understand the detailed evaluation process employed in tech recruitment. From initial applications to multiple interview stages, see how companies rigorously assess candidates to meet their specific technical needs.',
  },
  {
    title: 'Efficient Coordination of Final Technical Interviews',
    description: 'Experience the streamlined process of selecting top tech candidates and coordinating final technical interviews. Learn how organizations optimize their hiring workflow to ensure the best candidates progress smoothly.',
  },
  {
    title: 'Expert Management of Job Offers and Negotiations',
    description: 'Navigate the complexities of job offers and negotiations in the tech industry. From decision-making to offer extension, discover how companies effectively manage the hiring process for a seamless transition.',
  },
  {
    title: 'Comprehensive Oversight of Onboarding and Compliance',
    description: 'Explore the extensive support provided during the tech hiring journey. Leading firms not only focus on recruitment but also ensure smooth onboarding and compliance processes for a complete hiring experience.',
  },
];

export default responsibilities;
